import { render, staticRenderFns } from "./CloneBlockModal.vue?vue&type=template&id=99f2f9fa"
import script from "./CloneBlockModal.vue?vue&type=script&lang=js"
export * from "./CloneBlockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports